import React from "react";
import { SectionHeading } from "@/components/SectionHeading";
import { useContent } from "@/lib/useContent";

export const ClientGallery = () => {
  const gallery = useContent("client_gallery");
  if (!gallery || gallery.length === 0) return null;
  return (
    <section className="py-24 lg:py-32 bg-white" data-testid="client-gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading eyebrow="Client Gallery" title="Moments our travellers live for" subtitle="Real journeys arranged by Makchester — from desert sunsets to island escapes." />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {gallery.slice(0, 8).map((g, i) => (
            <div key={i} className={`group relative rounded-2xl overflow-hidden ${i % 4 === 1 || i % 4 === 2 ? "aspect-[3/4]" : "aspect-square"}`} data-testid={`gallery-item-${i}`}>
              <img src={g.image} alt={g.caption || "Makchester traveller moment"} loading="lazy"
                   className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              {g.caption && <div className="absolute bottom-0 inset-x-0 p-4 text-white text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity">{g.caption}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
